import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=43ca6a5d&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ca6a5d"]])

export default __exports__